import React from 'react'
import './Breadcrums.css'
import { Link } from 'react-router-dom'
import arrow_icon from '../Assets/breadcrum_arrow.png'

const Breadcrums = (props) => {
  const {product} = props;
  return (
    <div className='breadcrums'>
      <Link to="/">Inicio <img src={arrow_icon} alt="seta" /></Link>
      <Link to='/Lista-de-exames'>Lista de exames <img src={arrow_icon} alt="seta" /></Link>
      {product.name}
    </div>
  )
}

export default Breadcrums